/* Timo's story copy, Russian.
 *
 * This is a RETELLING of story.en.js, not a translation. Every line here is
 * spoken out loud by Timo to a Russian speaking child, so it is written the
 * way it should sound, not the way it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Тимо слушает. Тимо ждёт. Тимо помогает.
 *     Скажи вместе со мной, сказал Тимо.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They are picked
 * to be the easiest words in their chapter, not the prettiest, and they are
 * NOT translations of the English targets. Two of them were swapped because
 * the direct Russian word is too hard for a child with a speech delay:
 *     home  -> дом      kept, one syllable, early sounds д and м
 *     nut   -> белка    swapped, орех has a trilled р plus a final х
 *     water -> вода     kept, в and д are early, two syllables
 *     happy -> дети     swapped, счастливый is out of reach for this child
 * Every target is a concrete noun, appears at least twice in its chapter in
 * the plain nominative form, and carries the stress on a syllable a small
 * child can land on. Do not swap one for a nicer word.
 *
 * No em dashes or en dashes anywhere in this file, on purpose. Timo is read
 * aloud, and this project bans them in copy.
 */

const storyRu = {
  'story.title': 'Зелёный лес Тимо',
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Эй! Я попрошу моего друга Хоппи рассказать её.",

  // ==== Chapter 1: who Timo is ====
  'story.ch1':
    'Тимо живёт в большом зелёном лесу. Тимо маленький. У Тимо мягкий полосатый хвост. ' +
    'У Тимо большие круглые уши. Большими ушами хорошо слушать. В лесу живёт много зверей. ' +
    'Там живёт большой медведь. Там живёт маленький птенчик. Там живут две белки. ' +
    'Все говорят в одно и то же время. В лесу очень шумно. А Тимо не говорит первым. ' +
    'Тимо слушает. Тимо ждёт. Тимо помогает. Этот лес его дом. Тимо знает тут каждое дерево. ' +
    'Тимо знает большой тёплый камень. Его дом всегда тихий и тёплый. Тимо очень любит свой дом. ' +
    'Вечером он сидит и смотрит, как в небе встаёт луна.',
  'story.invite1': 'Зелёный лес это дом Тимо. Скажи вместе со мной, дом.',
  'story.word1': 'дом',
  'story.celebrate1': 'Дом! Как здорово получилось. У меня даже уши зашевелились.',
  'story.encourage1': 'Дом, дом, зелёный лес это мой дом. Пойдём, я познакомлю тебя с друзьями.',

  // ==== Chapter 2: the two squirrels ====
  'story.ch2':
    'Однажды две белки нашли орех. Орех был один, большой и вкусный. ' +
    'Первая белка хотела этот орех. Вторая белка тоже хотела этот орех. ' +
    'Они тянули его туда. Они тянули его сюда. Они не сказали ни слова. ' +
    'Они просто тянули и тянули. Тогда Тимо подошёл и сел рядом. ' +
    'Тимо слушает. Тимо ждёт. Тимо помогает. Потом Тимо сказал, расскажи, чего ты хочешь. ' +
    'Скажи вместе со мной, сказал Тимо. Первая белка сказала, я хочу орех. ' +
    'Вторая белка сказала, и я хочу орех. Вот теперь мы знаем, сказал Тимо. ' +
    'Орех можно поделить. Белки поделили орех пополам. Каждая белка была довольна.',
  'story.invite2': 'Две белки поделили орех пополам. Скажи вместе со мной, белка.',
  'story.word2': 'белка',
  'story.celebrate2': 'Белка! Как хорошо получилось. Обе белки машут тебе лапкой.',
  'story.encourage2': 'Белка, белка, две рыжие белки. А теперь пойдём к маленькому птенчику.',

  // ==== Chapter 3: the little bird, the heart of it ====
  'story.ch3':
    'Потом к Тимо прилетел маленький птенчик. Он сел на низкую ветку. Ему было жарко. ' +
    'Ему очень хотелось пить. Птенчик хотел что-то сказать, но слово не выходило. ' +
    'Он открыл клювик. Тихо. Он посмотрел вниз, на свои лапки. Никто его не торопил. ' +
    'Тимо слушает. Тимо ждёт. Тимо помогает. Тимо долго сидел рядом с ним, тихо и спокойно. ' +
    'Потом Тимо сам сказал это слово, медленно и мягко. Вода. ' +
    'Скажи вместе со мной, сказал Тимо. Птенчик попробовал. Во. Он попробовал ещё раз. Вода. ' +
    'У него получилось! Он сказал вода! Тимо запрыгал от радости. ' +
    'Весь зелёный лес радовался за маленького птенчика.',
  'story.invite3': 'Птенчик нашёл своё слово. Скажи вместе со мной, вода.',
  'story.word3': 'вода',
  'story.celebrate3': 'Вода! Получилось точно как у птенчика. Я очень рад за тебя.',
  'story.encourage3': 'Вода, вода, глоток прохладной воды. Пойдём посмотрим, что было дальше.',

  // ==== Chapter 4: the forest changes, Timo hears the children ====
  'story.ch4':
    'После того дня лес стал другим. Медведь захотел ягоду и сказал, ягода. ' +
    'Белки захотели играть и сказали, играть. Птенчик захотел пить и сказал, вода. ' +
    'Никто больше не тянул. Никто больше не толкал. Теперь у каждого было своё слово. ' +
    'Тимо был рад. И весь лес был рад. Однажды вечером Тимо сидел на тёплом камне ' +
    'и смотрел на луну. И вдруг он услышал что-то новое. ' +
    'Далеко, за деревьями, были дети. Дети хотели сказать очень много всего. ' +
    'Смешное, доброе, самое разное. Но слова не выходили наружу. Тимо сидел очень тихо. ' +
    'Тимо вспомнил маленького птенчика. Эти дети были совсем как он.',
  'story.invite4': 'Далеко за лесом Тимо услышал детей. Скажи вместе со мной, дети.',
  'story.word4': 'дети',
  'story.celebrate4': 'Дети! Какое хорошее слово, и оно прозвучало. Спасибо тебе.',
  'story.encourage4': 'Дети, дети, дети далеко за лесом. Пойдём со мной к самому концу.',

  // ==== Chapter 5: Timo comes to the child ====
  'story.ch5':
    'Утром Тимо собрал маленькую сумку. Он попрощался с большим медведем. ' +
    'Он попрощался с двумя белками. Он попрощался с маленьким птенчиком. ' +
    'Птенчик спел ему песенку, и в этой песенке было много слов. ' +
    'Все друзья махали ему вслед лапкой. ' +
    'Потом Тимо вышел из большого зелёного леса. Он шёл долго, долго. ' +
    'Всё это время его большие уши слушали. Тимо слушает. Тимо ждёт. Тимо помогает. ' +
    'И однажды, далеко от леса, он услышал тебя. И вот я здесь. Я уже не в лесу. ' +
    'Я рядом с тобой. И тебе есть что сказать. Мне очень хочется тебя услышать.',

  'story.ending':
    'Приходи завтра, и я расскажу тебе про медведя и про самую последнюю ягодку. Спокойной ночи, мой друг.',
};

export default storyRu;
